<template>
  <div class="mr-2">
    <v-btn
      icon
      color="white"
      @click="generateReport()"
    >
      <v-icon>mdi-file-pdf-box</v-icon>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Formato validación"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <img
                      src="@/assets/img/logo-puebla.png"
                      width="100%"
                      alt="a"
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>
                          DEPARTAMENTO DE INVESTIGACIÓN SOCIOECONÓMICA<br>
                          INFORME DE VALIDACIÓN DOCUMENTAL
                        </th>
                      </tr>
                    </thead>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DATOS PERSONALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="9">
                              <v-row>
                                <v-col cols="6">
                                  Nombre: {{ getFullName(evaluacion.Derivacion
                                    .Programacion.Expediente.Personal) }}
                                </v-col>
                                <v-col cols="6">
                                  RFC: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.rfc }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6">
                                  Institución:
                                  {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.unidadAnalisisTactico }}
                                </v-col>

                                <v-col cols="6">
                                  Puesto: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.unidadOperaciones }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  v-if="evaluacion.Derivacion.Programacion.CatMotivoEvaluacion"
                                  cols="6"
                                >
                                  Motivo de evaluación: {{ evaluacion.Derivacion
                                    .Programacion.CatMotivoEvaluacion.title }}
                                </v-col>
                                <v-col
                                  v-else
                                  cols="6"
                                >
                                  Motivo de evaluación: NO REGISTRADO
                                </v-col>
                                <v-col cols="6">
                                  Fecha:
                                  {{ getDate(evaluacion.Derivacion
                                    .Programacion.fechaEvaluacionPsicologica) }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <img
                                :src="evaluacion.Derivacion.Programacion.Expediente.Personal.foto"
                                crossorigin="anonymous"
                                width="100%"
                                alt="b"
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>ANTECEDENTES DE VALIDACIÓN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12" />
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <div class="html2pdf__page-break" />
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>
                          INFORMACIÓN DEL DOCUMENTO CON EL
                          QUE ACREDITA EL ÚLTIMO GRADO DE ESTUDIOS
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-row
                                v-for="(campo, index) in contenidoEstudios"
                                :key="index"
                              >
                                <v-col cols="6">
                                  {{ campo.text }}
                                </v-col>
                                <v-col
                                  cols="6"
                                  align="center"
                                >
                                  {{ getDataByIndex(index) }}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>INFORMACIÓN DE LA CARTILLA DE SERVICIO MILITAR</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-row
                                v-for="(campo, index) in contenidoCartilla"
                                :key="index"
                              >
                                <v-col cols="6">
                                  {{ campo.text }}
                                </v-col>
                                <v-col
                                  cols="6"
                                  align="center"
                                >
                                  {{ getDataCartillaByIndex(index) }}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>OBSERVACIONES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              {{ evaluacion.observaciones }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>

              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>ELABORÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              Validación DIS08
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>REVISÓ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              Jefe de departamento DIS03
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                cols="12"
                class="font mt"
              >
                Toda la información contenida en el presente documento está catalogada
                como CONFIDENCIAL de conformidad con la normatividad
                aplicable en los Artículos 3 Fracción II y 18 de la Ley Federal de
                Transparencia y Acceso a la Información Pública
                Gubernamental y por el Artículo 25 de la Ley de Acceso a la Información
                Pública y Protección de Datos Personales para el
                Estado de Morelos.
              </v-col>
            </v-row>
          </v-container>
        </section>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        margin: [8, 0, 8, 0],
      },
      contenidoEstudios: [
        { text: 'NIVEL DE ESTUDIOS' },
        { text: 'TIPO DE DOCUMENTO' },
        { text: 'INSTITUCIÓN ACADÉMICA' },
        { text: 'ESCUELA' },
        { text: 'FOLIO DE CERTIFICADO' },
        { text: 'FECHA DE TÉRMINO DE ESTUDIOS' },
        { text: 'OFICIO DE SOLICITUD DE VALIDACIÓN' },
        { text: 'FECHA DE OFICIO DE SOLICITUD' },
        { text: 'OFICIO DE RESPUESTA DE VALIDACIÓN' },
        { text: 'FECHA DE OFICIO DE RESPUESTA' },
        { text: 'RESULTADO' },
      ],
      contenidoCartilla: [{ text: 'OFICIO DE VALIDACIÓN' }, { text: 'FECHA DE OFICIO' }, { text: 'MATRÍCULA DE CARTILLA' }, { text: 'RESULTADO' }],
    };
  },

  computed: {
    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),
  },

  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    getDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },

    getDataByIndex(index) {
      switch (index + 1) {
        case 1:
          return this.estudios[0].CatEstudios.title;
        case 2:
          return this.estudios[0].ComprobanteEstudio.title;
        case 3:
          return this.estudios[0].institucion;
        case 4:
          return this.estudios[0].institucion;
        case 5:
          return '';
        case 6:
          return this.estudios[0].generacion;
        case 7:
          return this.evaluacion.oficioValidacion;
        case 8:
          return this.evaluacion.fechaOficio;
        case 9:
          return this.evaluacion.Derivacion.oficioRespuesta;
        case 10:
          return this.evaluacion.Derivacion.fechaOficioRespuesta;
        case 11:
          return this.evaluacion.resultado;
        default:
          return '';
      }
    },

    getDataCartillaByIndex(index) {
      switch (index + 1) {
        case 1:
          return this.evaluacion.oficioValidacion;
        case 2:
          return this.evaluacion.fechaOficio;
        case 3:
          return this.evaluacion.matriculaCartilla;
        case 4:
          return this.evaluacion.resultado;
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
    .font {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
    }
    th,
    tr {
        border: 1px solid;
    }
    .logo {
        border: 1px solid;
        height: 80px;
    }
    .mt {
        margin-top: 40px;
    }
    .margin {
        padding: 8px 48px 8px 48px;
    }
</style>
